export class ConfirmationCode {
  constructor({ attempts, codeSentAt, otpDeliveryMethod }) {
    Object.assign(this, {
      attempts,
      codeSentAt: Date.parse(codeSentAt),
      otpDeliveryMethod,
    });
  }
}
